import { createStoreCreator } from 'lib/store'
import reducer from 'reports/monthlyEvaluation/reducers'

export default createStoreCreator(reducer)
